import { map } from 'lodash';

export default (values, props) => {
  const error = {};
  const appraisal = props.appraisalsById[props.router.params.appraisalId];
  if (!appraisal) { return error; }
  const questions = appraisal.PMForm.QAElements.filter(q => q.QAElementType === 3);

  map(questions, ({
    QAElementID,
    QAInput,
    MinAnswers,
  }) => {
    /* No validation on checkbox questions */
    if (QAInput.QAInputAnswerType === 3) return;
    const key = `${QAInput.QAInputAnswerType}-${QAElementID}`;
    /* First check if element is required */
    if (MinAnswers > 0 && !values[key]) {
      error[key] = 'Þetta svæði verður að vera útfyllt';
      /* Second check if element has mask */
    } else if (QAInput && QAInput.QAMaskEntity) {
      if (QAInput.QAInputAnswerType === 5) return;
      const { QAMaskString, QAMaskDescription } = QAInput.QAMaskEntity;
      /* Create regex for the mask */
      const re = new RegExp(QAMaskString, 'i');
      if (!re.test(values[key])) {
        error[key] = QAMaskDescription;
      }
    }
  });

  return error;
};



// WEBPACK FOOTER //
// ./src/containers/utils/validateAppraisal.js